export const messages = {
    en: {
        actions: {},
        alerts: {
            current_model_deleted: 'This {0} has been deleted.',
        },
        models: {
            election: 'election | elections',
            member: 'member | members',
        },
        ui: {
            login: 'login',
        },
    },
    zh_CN: {
        actions: {
            associate_model: '关联{0}',
            create_model: '创建{0}',
            delete_model: '删除{0}',
            save: '保存',
            update_model_detail: '更新{0}详情',
            view_model_detail: '显示{0}详情',
        },
        alerts: {
            no_record_found: '没有记录',
            current_model_deleted: '此{0}已被删除', //'This {0} has been deleted.'
        },
        fields: {
            common: {
                id: 'ID',
                created_at: '创建时间',
                updated_at: '更新时间',
                deleted_at: '删除时间',
            },
            candidate: {
                votes_count: '选票数',
            },
            election: {
                name: '名称',
                datetime_start: '开始时间',
                datetime_end: '结束时间',
                description: '说明',
                cover_image: '图片',
                candidates_count: '候选人数',
                ballots_count: '投选人数',
            },
            member: {
                membership_number: '团员编号',
                full_name_cn: '中文名',
                full_name: '全名',
                state: '州属',
                join_date: '加入时间',
                nric: '身份证号',
                mobile: '手机',
                email: '电邮',
                gender: '性别',
                dob: '生日日期',
                address: '住址',
                remarks: '备注',
                is_active: '有效会员',
            },
            user: {
                name: '名字',
                mobile: '手机',
                email: '电邮',
                password: '密码',
                password_confirmation: '确认密码',
                role: '用户类型',
            },
        },
        labels: {
            existing_model: '现有{0}',
            new_model: '新{0}',
            select_all: '全选',
            submitted_at: '提交于',
        },
        models: {
            candidate: '候选人',
            election: '选举',
            member: '会员',
            user: '用户',
        },
        ui: {
            home: '首页',
            profile: '用户资料',
            login: '登录',
            logout: '登出',
            create: '创建',
            detail: '详情',
            update: '更新',
            delete: '删除',
            index: '目录',
            back: '返回',
            filter: '过滤',
            search: '搜索',
            reset: '重设',
            trashed: '已删除',
            with_trashed: '包括已删除',
            only_trashed: '只要已删除',
        },
    },
}
